import React from 'react';
import { Outlet } from 'react-router-dom';
import { KaziPeopleLogo } from '../components/KaziPeopleLogo';

const AuthLayout: React.FC = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-orange-50 dark:from-orange-500/[0.08] to-amber-50 dark:to-amber-500/[0.05] flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="flex flex-col items-center text-center mb-8">
          <KaziPeopleLogo size={44} />
          <p className="text-muted-foreground mt-3">Administrative Portal</p>
        </div>
        <Outlet />
      </div>
    </div>
  );
};

export default AuthLayout;